import { render, staticRenderFns } from "./ApplicationRenameOverlay.vue?vue&type=template&id=a53da21c&scoped=true"
import script from "./ApplicationRenameOverlay.vue?vue&type=script&lang=js"
export * from "./ApplicationRenameOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a53da21c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a53da21c')) {
      api.createRecord('a53da21c', component.options)
    } else {
      api.reload('a53da21c', component.options)
    }
    module.hot.accept("./ApplicationRenameOverlay.vue?vue&type=template&id=a53da21c&scoped=true", function () {
      api.rerender('a53da21c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ApplicationRenameOverlay.vue"
export default component.exports